// Localize server-generated explanations, including existing saved recipients.
export function localizeMatchReason(reason, language) {
  if (!reason || language !== "en") return reason;
  const text = reason.trim();
  if (text === "اطلاعات پژوهشی کافی برای اعلام تطابق تخصصی وجود ندارد؛ منبع و پروفایل رسمی را بررسی کنید.") {
    return "There is not enough research information to establish a match in expertise; review the source and official profile.";
  }
  const matched = text.match(/^تطابق ثبت‌شده در حوزه‌های (.+) با پروفایل شما\.$/u);
  return matched
    ? `Your profile matches the following recorded areas: ${matched[1].replace(/، /g, ", ")}.`
    : reason;
}
